<template>
  <div class="menu-view">
    <div class="page-header">
      <h3>查看可用菜单</h3>
      <span class="role-info">角色：{{ roleName }}</span>
    </div>

    <div class="toolbar">
      <el-button @click="goBack">返回</el-button>
    </div>

    <el-card v-loading="loading" shadow="never">
      <el-tree
        :data="menuData"
        node-key="key"
        default-expand-all
        :props="{ children: 'children', label: 'label' }"
      />
      <el-empty v-if="!loading && !menuData.length" description="该角色暂未分配菜单" />
    </el-card>
  </div>
</template>

<script>
import { getRoleMenus } from '@/api/permission'
import { asyncRoutes } from '@/router/routerMap'
import {
  buildMenuTree,
  flattenLeafMenuKeys
} from '@/utils/menuPermission'

export default {
  name: 'MenuView',
  data() {
    return {
      loading: false,
      roleId: '',
      roleName: '',
      menuData: []
    }
  },
  created() {
    this.roleId = this.$route.query.roleId
    this.roleName = this.$route.query.roleName || '未知角色'

    if (!this.roleId) {
      this.$message.error('缺少角色ID参数')
      return
    }
    this.loadRoleMenus()
  },
  methods: {
    async loadRoleMenus() {
      this.loading = true
      try {
        const response = await getRoleMenus({ role_id: this.roleId })
        if (response.err_code === 0) {
          const fullMenuTree = buildMenuTree(asyncRoutes)
          const data = response.data || {}
          const menuKeys = data.configured
            ? data.menu_keys || []
            : flattenLeafMenuKeys(fullMenuTree)
          this.menuData = this.filterMenuTree(fullMenuTree, new Set(menuKeys))
        } else {
          this.$message.error(response.err_msg || '加载菜单失败')
        }
      } catch (error) {
        console.error('加载菜单失败:', error)
        this.$message.error('加载菜单失败')
      } finally {
        this.loading = false
      }
    },
    filterMenuTree(menus, allowedKeys) {
      return menus.reduce((result, menu) => {
        const children = this.filterMenuTree(menu.children || [], allowedKeys)
        if (allowedKeys.has(menu.key) || children.length) {
          result.push({ ...menu, children })
        }
        return result
      }, [])
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.menu-view {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
}

.page-header h3 {
  margin: 0;
  color: #303133;
}

.role-info {
  color: #606266;
  font-size: 14px;
}

.toolbar {
  margin-bottom: 20px;
}
</style>
